module.exports = __webpack_public_path__ + "static/media/1.066e4e08.jpg";